import { useState } from 'react'
import Form from 'react-bootstrap/Form'
import InputLayout from '../InputLayout/InputLayout'
import Icon from '../../Icon/Icon'

const InputPassword = ({
    color = 'blue',
    disabled,
    error,
    id,
    label,
    name,
    onBlur,
    onChange,
    placeholder,
    touched,
    value,
    ...props
}) => {
    const [showPassword, setShowPassword] = useState(false)

    return (
        <InputLayout label={label} error={error} color={color} touched={touched}>
            <Icon
                name="lock"
                className={`position-absolute ps-3 top-50 translate-middle-y ${disabled && 'opacity-50'}`}
            />
            <Form.Control
                type={!showPassword ? 'password' : 'text'}
                className="rounded-0 px-8 text-formPrimary"
                placeholder={placeholder}
                isInvalid={error && touched}
                name={name}
                id={id}
                value={value}
                disabled={disabled}
                onChange={onChange}
                onBlur={onBlur}
                {...props}
            />
            <Icon
                name={!showPassword ? 'eye' : 'eye-filled'}
                className={`position-absolute end-0 pe-3 top-50 translate-middle-y ${disabled && 'opacity-50'}`}
                onClick={() => setShowPassword((prevState) => !prevState)}
                role="button"
            />
        </InputLayout>
    )
}

export default InputPassword
